import type { PropsWithChildren } from 'react';
import { ThemeContext } from 'styled-components';
import { useMemo, useState } from 'react';
import {
  GlobalStylesDefault,
  LOCAL_STORAGE_THEME,
  THEME_OPTIONS,
  THEMES_GLOBAL_STYLES,
} from '../domains';

type ThemeProviderProps = PropsWithChildren<unknown>;

export function ThemeProvider({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState(
    (localStorage.getItem(LOCAL_STORAGE_THEME) as THEME_OPTIONS) || THEME_OPTIONS.DEFAULT,
  );

  const themeContext = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);

  const ThemeGlobalStyles = THEMES_GLOBAL_STYLES[theme];

  return (
    <ThemeContext.Provider value={themeContext}>
      <GlobalStylesDefault />
      {ThemeGlobalStyles}
      {children}
    </ThemeContext.Provider>
  );
}
